import { createContext, useContext } from "react";

import type { RootStore } from "./RootStore";

/** Hands the root store to every component. */
export const StoresContext = createContext<RootStore | undefined>(undefined);

/** The root store, for components inside `StoresContext`. */
export function useStores(): RootStore {
    const stores = useContext(StoresContext);

    if (!stores) throw new Error("useStores() needs a StoresContext around it.");

    return stores;
}
